










import { defineComponent } from '@vue/composition-api';

import AverageDeliveryTimeByHub from '@/components/Report/04-DeliveryTime/AverageDeliveryTimeByHub.vue';

const DeliveryTimeByHub = defineComponent({
  components: {
    AverageDeliveryTimeByHub,
  },
  // setup() {},
});

export default DeliveryTimeByHub;
